import cx from 'classnames'
import { FC } from 'react'

import { useAppSelector } from 'src/redux/hooks'
import ShareDashboard from '../ShareDashboard'

import * as styles from './PageHeader.scss'

const PageHeaderShareDashboard: FC = () => {
  const isLoadingDone = useAppSelector(state =>
    state.root.loadingComponents.every(component => !component.loading),
  )

  return (
    <ShareDashboard
      className={cx(styles.PageHeaderIcon, '!bg-transparent !p-0')}
      isLoading={!isLoadingDone}
    />
  )
}

export default PageHeaderShareDashboard
